import { getGameFromUrl } from '@core/utils/urlParser';
import { resolveGameRouteSlug } from '@core/utils/resolveGameRouteSlug';

export { resolveGameRouteSlug };

/** Canonical route slugs that use the skyx_new game package and UI chrome. */
export const SKYX_NEW_ROUTE_SLUGS = new Set(['skyx_new', 'sky-x']);

/** CSS selector for body[data-game] rules shared by skyx_new and sky-x. */
export const SKYX_NEW_BODY_DATA_GAME_SELECTOR =
  'body[data-game="skyx_new"], body[data-game="sky-x"]';

export function isSkyxNewRoute(slug: string | null | undefined): boolean {
  if (!slug) return false;
  return SKYX_NEW_ROUTE_SLUGS.has(resolveGameRouteSlug(slug).toLowerCase());
}

export const CRASH_LAYOUT_ROUTE_SLUGS = new Set([
  'crash',
  'skyx',
  'sky-x',
  'skyx_new',
  'superdog',
  'cave-crasher',
  'chickenluck',
  'sky-sniffer',
  'sky-sniffer-v2',
  'city-sniffer',
]);

export function isCrashLayoutRoute(slug: string | null | undefined): boolean {
  if (!slug) return false;
  const canonical = resolveGameRouteSlug(slug).toLowerCase();
  return CRASH_LAYOUT_ROUTE_SLUGS.has(canonical);
}

/** Selected game that must not show the shared crash canvas outline. */
export function isOwnCanvasRoute(slug: string | null | undefined): boolean {
  if (!slug) return false;
  return !isCrashLayoutRoute(slug);
}

function syncOwnCanvasAttribute(slug: string | null): void {
  if (slug && isOwnCanvasRoute(slug)) {
    document.documentElement.setAttribute('data-own-canvas', '');
  } else {
    document.documentElement.removeAttribute('data-own-canvas');
  }
}

/** Keeps body[data-game] in sync with the active route (path or ?game=). */
export function syncBodyDataGameAttribute(game?: string | null): void {
  const slug = game ?? getGameFromUrl();
  if (slug) {
    document.body.setAttribute('data-game', resolveGameRouteSlug(slug));
    syncOwnCanvasAttribute(slug);
  } else {
    document.body.removeAttribute('data-game');
    syncOwnCanvasAttribute(null);
  }
}
